import React from 'react';

// En-tête d'une page de l'admin : titre serif, sous-titre, actions à droite.
interface PageHeaderProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  actions?: React.ReactNode;
}

const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, actions }) => (
  <div className="ui-page-header">
    <div className="ui-page-header-text">
      <h1 className="ui-display ui-page-title">{title}</h1>
      {subtitle && <p className="ui-page-subtitle">{subtitle}</p>}
    </div>
    {actions && <div className="ui-page-actions">{actions}</div>}
  </div>
);

export default PageHeader;
